import React from 'react';
import FacebookProvider, { Page } from 'react-facebook';

export class EmbeddedFacebook extends React.Component {

    render() {
        return (
            <FacebookProvider appId="1723914884341364">
                <Page href="https://www.facebook.com/HRRPNepal" />
            </FacebookProvider>
        );
    }
}
Page.defaultProps = {
    width: 370,
    height: 400,
    tabs: 'timeline',
    hideCover: true,
};